export default __webpack_public_path__ + "static/media/australia_icon.451ab752.png";